function proxyDefaultHandler<T>(defaultValue: (name: string) => T) {
  return {
    get: function (target: any, name: string) {
      if (!target.hasOwnProperty(name)) {
        target[name] = defaultValue(name);
      }

      return target[name];
    },
  };
}

/**
 * This is equivalent to ruby `Hash.new { |hash, key| hash[key] = defaultValue() }`
 *
 * @example:
 *
 * ```typescript
 * const obj = objectWithDefault(() => 0);
 * obj['a'] += 1;
 * obj['b'] += 2;
 * console.log(obj); // { a: 1, b: 2 }
 * ```
 */
export function objectWithDefault<T, K extends string = string>(
  defaultValue: (index: K) => T
): Record<K, T> {
  return new Proxy({}, proxyDefaultHandler(defaultValue));
}
